import React, { useState } from 'react';
import { Dialog } from './Dialog';
import { CorporateTrainingForm } from '../Payment/CorporateTrainingForm';
import { PaystackScript } from '../Payment/PaystackScript';
import { Check } from 'lucide-react';
import { Button } from './Button';
interface CorporateTrainingDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const CorporateTrainingDialog = ({
  isOpen,
  onClose
}: CorporateTrainingDialogProps) => {
  const [trainingStatus, setTrainingStatus] = useState<'pending' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setTrainingStatus('success');
  };
  const handleClose = () => {
    if (trainingStatus === 'success') {
      setTimeout(() => {
        setTrainingStatus('pending');
        setReference('');
      }, 300);
    }
    onClose();
  };
  return <>
      <PaystackScript data-id="element-1020" />
      <Dialog isOpen={isOpen} onClose={handleClose} title={trainingStatus === 'success' ? 'Training Request Successful' : 'Corporate Training Request'} size="md" data-id="element-1021">
        <div className="p-4" data-id="element-1022">
          {trainingStatus === 'pending' ? <CorporateTrainingForm onSuccess={handleSuccess} data-id="element-1023" /> : <div className="text-center py-6" data-id="element-1024">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-1025">
                <Check size={32} className="text-gray-700" data-id="element-1026" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1027">
                Training Request Confirmed
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1028">
                Thank you for requesting corporate training with The Networking
                Salon!
              </p>
              <p className="text-sm text-gray-500 mb-6" data-id="element-1029">
                Reference: {reference}
              </p>
              <p className="text-gray-600 mb-6" data-id="element-1030">
                Our team will reach out to you within 24 hours to finalize the
                training schedule and logistics.
              </p>
              <Button className="w-full" onClick={handleClose} data-id="element-1031">
                Close
              </Button>
            </div>}
        </div>
      </Dialog>
    </>;
};